import { render, staticRenderFns } from "./TicketsNum.vue?vue&type=template&id=4f322178"
import script from "./TicketsNum.vue?vue&type=script&lang=js"
export * from "./TicketsNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports